import { ExclamationIcon } from '@heroicons/react/outline/index';

const PreParing = ({ what, ...res }) => {
  return (
    <div
      className="max-w-sm bg-gray-100 p-8 flex flex-col gap-4 rounded mx-auto"
      {...res}
    >
      <ExclamationIcon className="h-16 text-primary" />
      <p className="text-sm text-primary text-center">
        현재 {what ? what + '(은/는)' : ''} 준비중입니다.
      </p>
    </div>
  );
};

export default PreParing;
